

export const projects = [
  {
    title: "Vicvia",
    subtitle: "FastAPI, OpenAI, Next.js, Tailwind, Vercel",
    description:
      `An AI-powered platform that breaks bigger goals into smaller, actionable steps and schedules them to google calendar with context aware AI coaching.`,
    image: "./vicvia-demo.mp4",
    link: "https://vicvia.com",
  },
    {
    title: "Wedet | Place Discovery",
    subtitle: "Fast API, Vue JS, Postgresql",
    description:
      `A web app to discover and rate places in Ethiopia`,
    image: "./wedet.png",
    link: "https://wedet.et",
  },
  {
    title: "Wedet AI Agent",
    subtitle: "Fast API, Python, Langchain ,OpenAI, Postgresql, Alpine.js",
    description:
      `An innovative AI agent that helps you discover places in Ethiopia unsing natural language.`,
    image: "./wedet-ai.mp4",
    link: "https://chat.wedet.et",
  },
  {
    title: "Recipe recommender",
    subtitle: "React",
    description:
      "This is a simple react application that gives list of recipes based on the maximum calorie intake number we provide to the app",
    image: "./recipe.png",
    link: "https://recipe-recommend.netlify.app/",
  },
  {
    title: "Image to Pdf converter telegram bot",
    subtitle: "Telegram Bot",
    description:
      "This telegram bot takes image convert it to pdf and outputs the pdf back to the user",
    image: "./bot.jpeg",
    link: "https://t.me/Imagetopdfdocbot",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "Python",
  "FastAPI",
  "Agentic AI",
  "Langchain",
  "Automation tools",
  "Docker",
  "AWS",
  "Web scraping",
  "Next.js",
  "Node.js",
  "Express.js",
  "Postgresql",
  "Alpine.js",
  "Django",
  "Django Rest Framework",
  "PHP",
  "Laravel",
  "React",
  "Angular",
  "Vue.js",
  "Astro" 
];



// WEBPACK FOOTER //
// ./src/data.js